module.exports = __webpack_public_path__ + "img/2.1489b7bf.jpg";